<template>
	<div class="container marketing-section px-0-md">
		<h2 class="heading-1 text-align-center"> User base growth over time </h2>
		<p class="body-lg text-color-content-secondary text-align-center mb-400-md mb-250-smo"
			>Fundrise has continuously grown its user base each year for the last ten years.</p
		>
		<div class="col-10-md col-9-lg ml-auto mr-auto">
			<IpoInvestorGrowthChart />
		</div>
		<p class="body-xs text-align-center text-color-content-tertiary mt-400-md mt-250-smo"
			><BaseButton classes="text-link text-color-content-tertiary" @click="openModal">Learn more</BaseButton>
			about the assumptions in this section.
		</p>
	</div>
</template>

<script setup lang="ts">
import DisclaimerSimple from '@components/disclaimer/disclaimer-simple.vue';
import IpoInvestorGrowthChart from '@charts/ipo-investor-growth-chart.vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

function openModal(): void {
	appStore.updateCurrentModal({
		modal: DisclaimerSimple,
		props: {
			title: 'About this section',
			content: [
				'This chart represents the cumulative total number of individuals that have created a Fundrise account, whether or not they have invested in any offerings, by year.'
			],
			centeredContent: false
		}
	});
}
</script>
